//import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
//import { ColDef, ColGroupDef, FilterModifiedEvent, GridApi, GridReadyEvent, Module, PaginationChangedEvent} from '@ag-grid-community/core';
import { HttpClient } from '@angular/common/http';
import {
  ColDef,
  Column, ColumnApi,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererComp,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
  SelectionChangedEvent
} from "ag-grid-community";
//import { Component, OnInit,Input ,ViewChild, TemplateRef } from '@angular/core';
import { Component, OnInit,Input ,ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CellClickedEvent, NumberFilter } from 'ag-grid-community';
import { saveAs } from 'file-saver';
//import { Input } from 'hammerjs';
//import { NgxSpinnerService } from 'ngx-spinner';
//import { LoaderService } from 'src/app/services/loader/loader.service';
import * as XLSX from 'xlsx';
//import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';  
import { event } from 'jquery';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { async } from 'rxjs';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
const { API_URL } = environment;

@Component({
  selector: 'app-real-time-risk-monitor',
  templateUrl: './real-time-risk-monitor.component.html',
  styleUrls: ['./real-time-risk-monitor.component.scss']
})

export class RealTimeRiskMonitorComponent implements OnInit {
  todayDate=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;

  @ViewChild('template') template: any;
  //modalRef: BsModalRef | undefined;  

  @Input() id?: string;
  isOpen = false;
  private element: any;
  modalConfigBlocked: ModalConfig;
  revenueReport:boolean=false;
  revenueReportgrid:boolean=true;
  isButtonShow:boolean=false;
  type:any;
  showgrid:boolean=false
  columnDefs:ColDef[]|any=[];  
  private filterObj: any = {};
  DynamicScreenControls: any;
  dynamicForm: FormGroup;
  screenId: any ;
  dynamicScreensData: any;
  merged_report_ids: any;
  control_event_dependent_control_Id:any;
  merge_keys: any;
  control_default_value:any;
  validation_regex:any={};
  controlMap = new Map();
  itemList:any=[];
  date:any=Date();
  bankdata:any
  Resbank:any
  tableSelectedColumn: ColDef[]|any = [];
  today = new Date();
  selectedTab: any;
  toggle = true;

rowData1 = [
  { pgRefNum: '1109130823125400',
    custName: 'Crafvilla',
    txnDate: "2023-08-23 12:54:04",
    orderId:"2023082300000752",
    mop:"UPI - UPI",
    custEamil: 'gajendrasisodia3108@gmail.com',
    baseAmount: '500.00',
    totalAmount: "529.50",
    currency:"INR",
    fraudScore:"56"  
  },
  ];
  rowData2 = [
    { pgRefNum: '1109130823125400',
      custName: 'Crafvilla',
      txnDate: "2023-08-23 12:54:04",
      orderId:"2023082300000752",
      mop:"UPI - UPI",
      custEamil: 'gajendrasisodia3108@gmail.com',
      baseAmount: '500.00',
      totalAmount: "529.50",
      currency:"INR",
      fraudScore:"56"  
    },
    ];
        
   gridOptions={
    columnDefs:this.columnDefs,
    pagination: true
    
   }
  public defaultColDef: ColDef|any = {
    flex: 1,
    minWidth: 150,
    filter: true,
    resizable: true,
    sortable:true,
    
  }
 
pipe = new DatePipe('en-US');
  private gridApi!: GridApi;
  currentPage: number = 1;
  pageSize=5;
  
  onPaginationChange(param: PaginationChangedEvent | any) {
    this.gridApi.paginationGoToPage(param - 1)
  }

  constructor(private formBuilder: FormBuilder, private http: HttpClient,
    private router: Router, private route: ActivatedRoute ,private datepipe:DatePipe) {
    this.dynamicForm = new FormGroup({     
     
    });
  }
  ngOnInit(): void {
    // this.getcoldef();
    this. date = this.datepipe.transform(this.date, 'yyyy-MM-dd');
    console.log('ngOnInitCalled');   
    this.route.paramMap.subscribe((params) => {
      console.log(params);
      this.sendRiskType('RN');
    });
    //this.onScreenLoad();
    this.modalConfigBlocked = {
      modalTitle: "Document",
      modalSize: 'xl',
   
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }  
  }
  
 
  ngAfterViewInit(): void {
    this.sendRiskType('RN');
  }

  sendRiskType(type:any){
    this.selectedTab=type;
        if(type=='IT'){
     
      this.fetchScreen('35',type);
      this.showgrid=false 
    }
    else if(type=='BS'){
      
      this.showgrid=false
      this.fetchScreen('36',type);
    }
    else if(type=='CB'){
     
      this.showgrid=false
      this.fetchScreen('37',type);
    }
    else if(type=='RN'){
     
      this.showgrid=false
      this.fetchScreen('34',type);
    }
    else if(type=='HRN'){
    
      this.showgrid=false
      this.fetchScreen('38',type);
    }
  }

  

  

downloadExcel() {
  debugger
  let fileTitle = this.DynamicScreenControls[0].title + ".xlsx";
 let rowData= this.rowData.map((data:any) => {
  if(data.ipAddress){
    debugger
    //alert("inside ipAdrress")
  //  let inputDate:any
  //   const year = data.currentDate.slice(0, 4);
  //   const month = data.currentDate.slice(4, 6);
  //   const day = data.currentDate.slice(6, 8);
  //   const date = new Date(`${year}-${month}-${day}`);
  //   inputDate = date.toISOString().substring(0, 10);
    debugger  
    return {
      "Pay Id": data.payId,
      "Business Name": data.businessName,      
      "Date": data.currentDate,
      "Total Txn": data.totalTxn,    
      "IP Address": data.ipAddress,
      "Threshold": data.percentage,         
    }
  }
  if(data.browserDeviceId){
    return {
      "Pay Id": data.payId,
      "Business Name": data.businessName,     
      "Date": data.currentDate,
      "Threshold": data.percentage,
      "Total Txn": data.totalTxn,
      "Browser Id": data.browserDeviceId,        
    }
  }
  if(data.email_fraud_score){  
    return {
      "PG REF No": data.pgRefNum,
      "Merchant Name": data.businessName,
      "Txn Date": data.txnDate,
      "MOP Method": data.mop_type,
      "Customer Email": data.email_id,
      "Base Amount": data.amount,
      "Total Amount": data.total_amount,
      "Fraud Score": data.email_fraud_score,     
    }
  }
  if(data.Total_Txn_Count){
    let inputDate:any
    const year = data.Last_Updated_On.slice(0, 4);
    const month = data.Last_Updated_On.slice(4, 6);
    const day = data.Last_Updated_On.slice(6, 8);

    const date = new Date(`${year}-${month}-${day}`);
    inputDate = date.toISOString().substring(0, 10);  

    return {
      "Pay Id": data.Merchant_Pay_Id,
      "Merchant Name": data.Merchant_Name, 
      "Total Txn count": data.Total_Txn_Count,
      "Total Txn Amount": data.Total_Txn_Amount,
      "Total CB Count ": data.Total_CB_Count,
      "Total_CB_Amount": data.Total_CB_Amount,
      "Percentage": data.Percentage,  
      "Last Upadated On": inputDate,   
    }
  }
  else{
    return {
      "Pay Id": data.payId,
      "Business Name": data.businessName,
      "Previous Date": data.previousDate,
      "Current Date": data.currentDate,
      "Previous Amount": data.previousAmount,
      "Current Amount": data.currentAmount,
      "Threshold": data.percentage,
      "Hike Percentage": data.hikePercentage,     
    }
  }
  }
  )
  this.exportAsExcelFile(rowData, fileTitle);
  }
  public exportAsExcelFile(rowData: any[], fileName: string): void {
debugger

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    debugger
    const data: Blob = new Blob([buffer], {type: 'application/octet-stream'});
    const url: string = window.URL.createObjectURL(data);
    const link: any = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  }

  onSubmit() {
    const data: any = {};
    this.DynamicScreenControls.forEach((f: any) => {
      data[f.control_id] = this.dynamicForm.get(f.control_id) ? this.dynamicForm.get(f.control_id)?.value : '';
    })
    if(this.type=='IT'|| this.type=='BS'|| this.type=='HRN'){
      data['DATE'] = (data['DATE']=='' ||data['DATE']==null)? this.datepipe.transform(this.today, 'yyyy-MM-dd'):this.datepipe.transform(data['DATE'], 'yyyy-MM-dd');
      }
    data['report_ids'] = this.merged_report_ids;
    data['merge_keys'] = this.merge_keys;
    if(this.type=='RN'){
      data['type'] ="RISK" ;
      }
      if(this.type=='HRN'){
        data['type'] ="HIGHRISK" ;
        }
    data['control_default_value']=this.control_default_value;
     let formData = Object.keys(data);
    for (let key in formData) {
      let controlKey = formData[key];
      let controlVal = data[controlKey];
      let validationRegex = this.controlMap.get(controlKey) ? this.controlMap.get(controlKey).validation_regex : null;      
      let regex = new RegExp(validationRegex);
      if (controlVal !== null && controlVal !== '' && validationRegex !== null &&  !regex.test(controlVal)) {
        alert("Please provide valid value for " + controlKey);
        let element = document.getElementById(controlKey);
        if (element) {
          element.focus();
        }
        return false;       
      }
  }  
    this.http.post(`${API_URL}/dReport/fetchReport`,data).subscribe((response: any) => {
        if (response.status == true) {
          const colDefs=this.columnDefs;
          colDefs.length=0;
          let headerFields = response.data[response.data.length - 1];
          response.data.pop(response.data[response.data.length - 1]);
          Object.entries(headerFields).forEach((elements) => {
            if (elements[1] === " ") {
              return;
            }
            colDefs.push(
              {
                field: elements[0],
                headerName: elements[1],
                resizable: true,
                suppressSizeToFit: false
              }
            );
            this.tableSelectedColumn = [...this.columnDefs];            
            this.columnDefs=colDefs;
            if(this.type=='IT'){
            const productsWithPrice = response.data.map((product:any) => {
              return { ...product,"currentDate":  new Date(`${product.currentDate.slice(0, 4)}-${product.currentDate.slice(4, 6)}-${product.currentDate.slice(6, 8)}`).toISOString().substring(0, 10),
                
            };
            });
            this.rowData=productsWithPrice;
            this.gridApi.setRowData(this.rowData); 
          }
          else if(this.type=='CB'){
            const productsWithPrice = response.data.map((product:any) => {
              return { ...product,"Last_Updated_On":  new Date(`${product.Last_Updated_On.slice(0, 4)}-${product.Last_Updated_On.slice(4, 6)}-${product.Last_Updated_On.slice(6, 8)}`).toISOString().substring(0, 10),
            };
            });
            this.rowData=productsWithPrice;
            this.gridApi.setRowData(this.rowData); 
          }
          else{
            this.rowData=response.data;
            this.gridApi.setRowData(this.rowData); 
          }           
        });
       }
      })
      return true;
  }

  fetchScreen(screenId: any,type:any) {
    this.type=type;
    debugger
    this.rowData=[]
     this.http.post(`${API_URL}/dReport/fetchScreen`, { 'screenId': screenId })
      .subscribe((response: any) => {
        if (response['status'] == true) {
          const controls: any = [];
          response.data.forEach((res: any) => {
            const validationsArray: any = [];
            this.controlMap.set(res.control_id, res);
            if (res.optional === "N") {
              validationsArray.push(Validators.required);
            }
            controls[res.control_id] = new FormControl(null, validationsArray);           
            console.log(controls[res.control_id]);
            console.log("control_default_value====="+controls[res.control_default_value]);
          });
          this.dynamicForm = this.formBuilder.group(controls); 
          this.DynamicScreenControls = response.data;  
          console.log("DynamicScreenControls===="+JSON.stringify(this.DynamicScreenControls))        
          this.merged_report_ids = this.DynamicScreenControls[0].report_ids;
          this.merge_keys = this.DynamicScreenControls[0].merge_keys;
        }
      if(response.status){
        if(screenId=='34' || screenId=='37'){
          this.isButtonShow=true;
          this.onSubmit();
        }
        else{         
          this.isButtonShow=false;
         this.onSubmit();
      
        }
      }
  })
}

  onFilterModified(param: FilterModifiedEvent | any) {
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  rowData: any=[]
  gridColumnApi: any;
  onGridReady(params: GridReadyEvent|any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setColumnDefs(this.columnDefs);
  }
  onDynamicButtonClick(control:any){
    var data: any = {};
    this.DynamicScreenControls.forEach((f: any) => {
      data[f.control_id] = this.dynamicForm.get(f.control_id) ? this.dynamicForm.get(f.control_id)?.value : '';      
    })
    
    debugger
    var screen =this.screenId;    
    data["report_ids"] = screen;
    //http://10.0.8.200:8080/screen_submit/execute/1
    //this.http.post(control.control_default_value, data)
     //this.http.post('http://localhost:8081/AcquirerMaster', data)
     this.http.post(`${API_URL}/dReport/fetchReport`, data)
    .subscribe((response: any) => {
     this.downloadExcel();
      debugger
     if(response.http_status=='OK'){
      alert("Successfully! Saved");
     }else{
      alert("Failed to save");
     }
  });
}
  changeEvent(event:any){
    let controlId = event.target.id;
    let controlVal = event.target.value;
    let childId = "";

    this.DynamicScreenControls.forEach((f: any) => {
      if (f.control_id === controlId) {
        childId = f.control_event_dependent_control_Id;
        return;
      }
    });

    let childControlDetail = this.controlMap.get(childId);
    let options = "<option value=''>ALL</option>";
    childControlDetail.list_of_values.forEach((dependentValues: any) => {
      if (dependentValues.dependentId === controlVal) {
        options += "<option value='" + dependentValues.value + ">" + dependentValues.key + "</option>";
      }
    });
    let dependEle = document.getElementById(childId);
    if (dependEle) {
      dependEle.innerHTML = options;
    }
  }

  currenttPage:number=1;
  onPageChange(event:any) {
    debugger
  this.currenttPage = event;
  }
  
  get pageCount(): number {
    return Math.ceil(this.itemList.length / this.pageSize);
  }

  
  
aa:any=[ 
  { action: "verify_with_source", 
  completed_at: "2023-08-23T11:25:51+05:30",
  created_at: "2023-08-23T11:25:50+05:30",
   group_id : "67640576-2a1e-41e8-94cd-d340567e7bf8",
   request_id: "fdd7051f-c480-4c9d-9ee2-471660ace160", 
  result: {
     source_output:
     { advanced: {
      //  dns_status: "valid",
      //  "domain_age": { human: "28 years ago", iso: "1995-08-13T00:00:00-04:00", timestamp: 808286400 },
  //  email_server_status: "valid", 
     first_seen: { human: "2 weeks ago", iso: "2023-08-08T09:30:26-04:00", timestamp: 1691501426 }, 
     sanitized_email: "gajendrasisodia3108@gmail.com" 
    },
    email_deliverability: "high", 
    first_name: "Unknown",
     fraud_and_abuse: { email_fraud_score: 45, is_catch_all: false, is_disposable: false, is_recently_abused: false }, 
    is_common_domain: true, is_dns_valid: true, is_email_valid: true, is_frequent_complainer: false,
     risk: { is_generic: false, is_honeypot: false, is_leaked: false, spam_trap_score: 0 }, 
    status: "id_found", suggested_domain: "N/A" } 
    },
     status: "completed", task_id: "cdb3df86-5464-468d-a36c-34fc87d1449f", type: "email" } ]

     
 
   dvalue:any
  OnRowClicked(param: RowClickedEvent | any){
    this.aa;
    this.dvalue=param.data
    this.modalblockedComponent.open();
  }

  
}


